import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getMembers, approveMember, suspendMember, reactivateMember } from '../../services/members';
import DataTable from '../../components/Tables/DataTable';
import Toast from '../../components/Common/Toast';

const Members = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    loadMembers();
  }, []);

  const loadMembers = async () => {
    try {
      // Backend will automatically filter members belonging to the user's assigned admin units
      const data = await getMembers();
      setMembers(data);
    } catch (err) {
      setToast({ type: 'error', message: 'Failed to load members' });
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      await approveMember(id);
      setToast({ type: 'success', message: 'Member approved' });
      loadMembers();
    } catch (err) {
      setToast({ type: 'error', message: err.response?.data?.error });
    }
  };

  const handleSuspend = async (id) => {
    try {
      await suspendMember(id);
      setToast({ type: 'success', message: 'Member suspended' });
      loadMembers();
    } catch (err) {
      setToast({ type: 'error', message: err.response?.data?.error });
    }
  };

  const handleReactivate = async (id) => {
    try {
      await reactivateMember(id);
      setToast({ type: 'success', message: 'Member reactivated' });
      loadMembers();
    } catch (err) {
      setToast({ type: 'error', message: err.response?.data?.error });
    }
  };

  const columns = [
    { key: 'member_number', label: 'Member ID' },
    { key: 'full_name', label: 'Name' },
    { key: 'email', label: 'Email' },
    { key: 'status', label: 'Status' },
    {
      key: 'actions',
      label: 'Actions',
      render: (_, row) => (
        <>
          <Link to={`/dashboard/unit-admin/members/${row.id}`}>View</Link>
          {row.status === 'pending' && <button onClick={() => handleApprove(row.id)}>Approve</button>}
          {row.status === 'active' && <button onClick={() => handleSuspend(row.id)}>Suspend</button>}
          {row.status === 'suspended' && <button onClick={() => handleReactivate(row.id)}>Reactivate</button>}
        </>
      ),
    },
  ];

  return (
    <div>
      <h1>Unit Members</h1>
      <DataTable columns={columns} data={members} loading={loading} />
      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
};

export default Members;